import type { MonthlyPrice } from "@cf247/pricing";

/** The display status shown for a quote, falling back to a derived value when absent. */
export const getDisplayStatus = (q: MonthlyPrice): string =>
  q.displayStatus || (q.failed ? "Failed Rules" : "Processing");

/** Returns the quote's status label when it is stuck in processing, otherwise null. */
export function isQuoteProcessing(quote: MonthlyPrice | null | undefined): string | null {
  if (!quote) return null;
  if (getDisplayStatus(quote) === "Manual Processing") return "Manual Processing";
  if (getDisplayStatus(quote) === "Processing") return "Processing";
  return null;
}

/** Returns the quote's status label when it has a provisional/conditional acceptance, otherwise null. */
export function isQuoteProvisionalAcceptance(quote: MonthlyPrice | null | undefined): string | null {
  if (!quote) return null;
  if (getDisplayStatus(quote) === "Provisional Acceptance") return "Provisional Acceptance";
  if (getDisplayStatus(quote) === "Conditionally Accepted") return "Conditionally Accepted";
  return null;
}
